import React from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import classnames from "classnames";
import { replaceSpecialChars } from "utils/Utilities";

function TranslateFormInput({
  customNamespace,
  customParam,
  customValues,
  id,
  disabled,
  title,
  translations,
  translationsIndexes,
  maxLength,
  fieldName,
  onChange,
  onChangeDefaultName,
  languages,
  labelClassName,
  inputClassName,
  t,
}) {
  const onChangeTrans = (translation, value) => {
    const language = translation.language_uuid || translation.language;

    const targetIndex = translation.language_uuid
      ? translationsIndexes.language_uuid[language][0]
      : translationsIndexes.language[language][0];

    translations[targetIndex][
      customParam ? `${fieldName}_${customParam}` : fieldName
    ] = value;

    if (fieldName === "name")
      onChangeDefaultName({
        translations,
        value: replaceSpecialChars(value.toLowerCase()),
        language,
      });
    else onChange(translations, translation.language);
  };

  const getLanguageUuid = (language) => {
    let language_uuid = null;
    languages.data.forEach((it) => {
      if (it.language === language) {
        language_uuid = it.uuid;
      }
    });
    return language_uuid;
  };

  return (
    <div className="editor-form-translates">
      <div className="editor-form-section-title">{title}</div>
      {translations?.map((translation) => {
        const language_uuid =
          translation.language_uuid || getLanguageUuid(translation.language);

        if (!language_uuid) return;

        const index = languages.indexes.uuid[language_uuid];
        const { language } = languages.data[index] || translation.language;

        let value =
          customValues &&
          customValues[language] &&
          customValues[language][customNamespace] &&
          customValues[language][customNamespace][customParam];

        if (!value && !customParam) {
          value = translation[fieldName];
        } else if (value) {
          value =
            typeof value === "object"
              ? customValues[language][customNamespace][customParam][fieldName]
              : JSON.parse(
                  customValues[language][customNamespace][customParam],
                )[fieldName];
        }

        const inputClassNameList = classnames(
          "editor-form-input-title",
          inputClassName,
        );

        return (
          <div
            key={`${id}-title-${language}`}
            className="editor-form-translate"
          >
            <label className={labelClassName} htmlFor={`${id}-${language}`}>
              {t(`languages:langs.${language}`)}
              {translation.default && "*"}
            </label>
            <input
              key={`${id}-value-${language}`}
              id={`${id}-${language}`}
              disabled={disabled}
              type="text"
              className={inputClassNameList}
              value={value}
              maxLength={maxLength}
              onChange={(e) => {
                onChangeTrans(translation, e.target.value);
              }}
            />
          </div>
        );
      })}
    </div>
  );
}

TranslateFormInput.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  customNamespace: PropTypes.string,
  customParam: PropTypes.string,
  customValues: PropTypes.object,
  disabled: PropTypes.bool,
  maxLength: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onChangeDefaultName: PropTypes.func,
  translations: PropTypes.array.isRequired,
  translationsIndexes: PropTypes.object.isRequired,
  languages: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  inputClassName: PropTypes.string,
  labelClassName: PropTypes.string,
};

const mapStateToProps = (state) => {
  const { languages } = state.fetchReducer;

  return {
    languages,
  };
};

export default connect(mapStateToProps)(
  withTranslation(["languages"])(TranslateFormInput),
);
